import React from 'react';
import './App.css'; // Import your CSS file for styling

export default function Home() {
  return (
    <div className="homepage-container">
      <main className="main-content">
        <section className="intro-section">
          <h2>Welcome to Our Payroll Management System</h2>
          <p>
            Discover in-depth  buisness by using payrole management system 
          </p>
        </section>
        <br />
        <br />
        <section className="features-section">
          <div className="feature-box">
            <h3>Employees</h3>
            <p>All employees details are stored , can tap and view comolete details</p>
          </div>
          <div className="feature-box">
            <h3>Departments</h3>
            <p>Department name and number of Emp working in each .</p>
          </div>
          <div className="feature-box">
            <h3>Payroll</h3>
            <p>View the Finance related matter .</p>
          </div>
        </section>
      </main>
      <footer className="footer">
        <p>&copy; 2023 Payroll Management System. All rights reserved.</p>
      </footer>
    </div>
  );
}
